/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_ContinueInputs */

const en_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const de_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const fr_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const es_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const it_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const nl_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorgaan`)
};

const pl_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalej`)
};

const fi_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jatka`)
};

const da_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsæt`)
};

const sv_cancel_continue = /** @type {(inputs: Cancel_ContinueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsätt`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Cancel_ContinueInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_continue = /** @type {((inputs?: Cancel_ContinueInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_ContinueInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_continue(inputs)
	if (locale === "fr") return fr_cancel_continue(inputs)
	if (locale === "es") return es_cancel_continue(inputs)
	if (locale === "it") return it_cancel_continue(inputs)
	if (locale === "nl") return nl_cancel_continue(inputs)
	if (locale === "pl") return pl_cancel_continue(inputs)
	if (locale === "fi") return fi_cancel_continue(inputs)
	if (locale === "da") return da_cancel_continue(inputs)
	if (locale === "sv") return sv_cancel_continue(inputs)
	return en_cancel_continue(inputs)
});